import { render, staticRenderFns } from "./Diy2BannerSkeleton.vue?vue&type=template&id=0b001118&scoped=true&"
import script from "./Diy2BannerSkeleton.vue?vue&type=script&lang=js&"
export * from "./Diy2BannerSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./Diy2BannerSkeleton.vue?vue&type=style&index=0&id=0b001118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b001118",
  null
  
)

export default component.exports